import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private readonly cacheDuration = 12 * 60 * 60 * 1000;

  constructor() {}

  setCache(key: string, value: string): void {
    const expiryTime = Date.now() + this.cacheDuration;
    const cacheData = {
      value,
      expiryTime
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
  }

  getCache(key: string): string | null {
    const cacheData = localStorage.getItem(key);
    if (!cacheData) {
      return null;
    }

    const { value, expiryTime } = JSON.parse(cacheData);
    if (Date.now() > expiryTime) {
      localStorage.removeItem(key);
      return null;
    }

    return value;
  }
}
